import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../Checkbox';

import { StyledWrapper, StyledLabel, HiddenDiv } from './CartCheckboxStyles';

var CartCheckbox = function CartCheckbox(props) {
  return React.createElement(
    StyledWrapper,
    null,
    React.createElement(
      StyledLabel,
      null,
      props.toolTip && props.toolTip,
      props.text,
      ' ',
      React.createElement('input', {
        'aria-label': props.text,
        checked: props.checked,
        disabled: props.disabled,
        onChange: props.onChange,
        type: 'checkbox'
      }),
      React.createElement(Checkbox, {
        checked: props.checked,
        width: '15px',
        styles: { marginLeft: '8px' }
      })
    ),
    React.createElement(
      HiddenDiv,
      { active: props.checked, maxHeight: props.maxHeight || '100px' },
      props.children
    )
  );
};

CartCheckbox.propTypes = {
  text: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  maxHeight: PropTypes.string,
  toolTip: PropTypes.element,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

export default CartCheckbox;